// extracted by mini-css-extract-plugin
export default {"ctaContainer":"ExploreAuthors_ctaContainer__5O8ru","textContent":"ExploreAuthors_textContent__JR7qJ","ctaButton":"ExploreAuthors_ctaButton__A7LmU"};